import xProductPartNumbersStyles from "@flip/App/SharedStyle/ProductPartNumbersStyles";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsFlipPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const partNumberStyles: ProductDetailsFlipPartNumberStyles = {
    labelText: xProductPartNumbersStyles.large.label,
    valueText: xProductPartNumbersStyles.large.value,
};

const styles = partNumberStyles;

const ProductDetailsFlipPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.detail?.sku) {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsFlipPartNumber">
            <Typography {...styles.labelText}>{translate("FPN#")}</Typography>
            {product.detail?.sku}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsFlipPartNumber),
    definition: {
        displayName: "Flip Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
